import { useMemo } from "react";

import type { HotelNotificationSettingQueryQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandHeader, FeatureIslandMain } from "@/components/features/_layouts";

import type { ButtonProps } from "@/components/ui/button/button";
import { Button } from "@/components/ui/button/button";

import { HotelNotificationSettingsMain } from "./components";
import { useActions } from "./hooks";
import * as UseCase from "../model/use-case";

type Props = {
	data: HotelNotificationSettingQueryQuery;
};

export const HotelNotificationSettingsPresenter = ({ data }: Props) => {
	const { viewModel, onSetViewModel, onUpdateHotelNotificationSettings } = UseCase.useInitialized({
		data,
	});

	const {
		onAppendReservationNotificationEmail,
		onRemoveReservationNotificationEmail,
		onChangeReservationNotificationEmail,
		//
		onAppendEcNotificationEmail,
		onRemoveEcNotificationEmail,
		onChangeEcNotificationEmail,
		//
		onAppendPaymentNotificationEmail,
		onRemovePaymentNotificationEmail,
		onChangePaymentNotificationEmail,
	} = useActions(viewModel, onSetViewModel);

	const variant = useMemo<ButtonProps["variant"]>(
		() => (!viewModel.hasError && viewModel.isDirty ? "default" : "disabled"),
		[viewModel.hasError, viewModel.isDirty],
	);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="通知の設定"
				rightChildren={
					<Button variant={variant} size="xl" onClick={onUpdateHotelNotificationSettings}>
						保存
					</Button>
				}
			/>
			<FeatureIslandMain>
				<HotelNotificationSettingsMain
					reservationNotificationEmails={viewModel.reservationNotificationEmails}
					ecNotificationEmails={viewModel.ecNotificationEmails}
					paymentNotificationEmails={viewModel.paymentNotificationEmails}
					onAppendReservationNotificationEmail={onAppendReservationNotificationEmail}
					onChangeReservationNotificationEmail={onChangeReservationNotificationEmail}
					onRemoveReservationNotificationEmail={onRemoveReservationNotificationEmail}
					onAppendEcNotificationEmail={onAppendEcNotificationEmail}
					onChangeEcNotificationEmail={onChangeEcNotificationEmail}
					onRemoveEcNotificationEmail={onRemoveEcNotificationEmail}
					onAppendPaymentNotificationEmail={onAppendPaymentNotificationEmail}
					onChangePaymentNotificationEmail={onChangePaymentNotificationEmail}
					onRemovePaymentNotificationEmail={onRemovePaymentNotificationEmail}
				/>
			</FeatureIslandMain>
		</FeatureIslandContainer>
	);
};
